import { auth, user } from '@/services'

export const renewHeaders = async (response) => {
  const { headers } = response

  if (headers['access-token'] && headers['expiry']) {
    const data = Object.assign(user.getUserData(), {
      headers: {
        'access-token': headers['access-token'],
        'token-type': headers['token-type'],
        'client': headers['client'],
        'expiry': headers['expiry'],
        'uid': headers['uid']
      }
    })

    auth.setUserAuthData(data)
  }
}
